import { render, staticRenderFns } from "./EventText.vue?vue&type=template&id=2930b223"
import script from "./EventText.vue?vue&type=script&lang=js"
export * from "./EventText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports